export default __webpack_public_path__ + "static/media/cauliflowerbites@2x.f8cc6752.jpg";